import { render } from "./TileFixed.vue?vue&type=template&id=0fbf7fed&scoped=true"
import script from "./TileFixed.vue?vue&type=script&lang=js"
export * from "./TileFixed.vue?vue&type=script&lang=js"

import "./TileFixed.vue?vue&type=style&index=0&id=0fbf7fed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbf7fed"]])

export default __exports__